/* ==========================================================================
   THE SNAX LAB — HALLOWEEN SEASONAL LAYER (behaviour)
   --------------------------------------------------------------------------
   Three things:
     1. The two fixed corner cobwebs.
     2. Ghosts that drift through once as the page loads, then remove themselves.
     3. The spider, which descends on its silk as you scroll, sweeps across the
        page, and bolts if your cursor or finger gets close.

   Nothing here ever takes pointer events. The spider reacts to the pointer by
   measuring how near it is, not by sitting in front of the page — so it can
   never swallow a click on a product or a button.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__hwHalloweenLoaded) return;
  window.__hwHalloweenLoaded = true;

  var reduceMotion = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----------------------------------------------------------------- shapes */
  var SPIDER_SVG =
    '<svg class="hw-spider-svg" width="60" height="72" viewBox="0 0 60 72" ' +
    'xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      '<g fill="none" stroke="#ff7518" stroke-width="1.7" stroke-linecap="round">' +
        '<g class="hw-leg hw-leg--a">' +
          '<path d="M22 25Q9 14 2 19"/><path d="M38 25Q51 14 58 19"/>' +
        '</g>' +
        '<g class="hw-leg hw-leg--b">' +
          '<path d="M21 29Q5 26 1 34"/><path d="M39 29Q55 26 59 34"/>' +
        '</g>' +
        '<g class="hw-leg hw-leg--c">' +
          '<path d="M21 33Q6 40 3 48"/><path d="M39 33Q54 40 57 48"/>' +
        '</g>' +
        '<g class="hw-leg hw-leg--d">' +
          '<path d="M22 37Q11 50 8 60"/><path d="M38 37Q49 50 52 60"/>' +
        '</g>' +
      '</g>' +
      '<ellipse cx="30" cy="46" rx="12.5" ry="15" fill="#0d0a14" ' +
        'stroke="#ff7518" stroke-width="1.8"/>' +
      '<ellipse cx="30" cy="28" rx="8" ry="7" fill="#0d0a14" ' +
        'stroke="#ff7518" stroke-width="1.8"/>' +
      '<path d="M25 44q5 4 10 0M24 50q6 4 12 0" stroke="#6d28d9" ' +
        'stroke-width="1.4" fill="none" stroke-linecap="round"/>' +
      '<g class="hw-eye">' +
        '<circle cx="27" cy="26" r="2.1" fill="#8cff3d"/>' +
        '<circle cx="33" cy="26" r="2.1" fill="#8cff3d"/>' +
      '</g>' +
    '</svg>';

  var GHOST_SVG =
    '<svg viewBox="0 0 80 100" xmlns="http://www.w3.org/2000/svg" ' +
    'aria-hidden="true" focusable="false">' +
      '<path d="M8 76L8 36C8 16 24 2 40 2C56 2 72 16 72 36L72 76L62 64L53 76' +
        'L44 64L35 76L26 64L17 76Z" fill="rgba(246,242,233,0.10)" ' +
        'stroke="rgba(246,242,233,0.55)" stroke-width="2.4" stroke-linejoin="round"/>' +
      '<ellipse cx="29" cy="36" rx="4.5" ry="6.5" fill="rgba(246,242,233,0.6)"/>' +
      '<ellipse cx="51" cy="36" rx="4.5" ry="6.5" fill="rgba(246,242,233,0.6)"/>' +
      '<ellipse cx="40" cy="55" rx="6" ry="8" fill="rgba(246,242,233,0.32)"/>' +
    '</svg>';

  /* ---------------------------------------------------------- arrival ghosts */
  var GHOSTS = [
    { left: '11%', top: '54%', w: 92,  dx: -130, dy: -330, dur: 4.2, delay: 0.15, peak: 0.5 },
    { left: '67%', top: '66%', w: 124, dx: 165,  dy: -390, dur: 4.9, delay: 0.5,  peak: 0.42 },
    { left: '41%', top: '78%', w: 72,  dx: -45,  dy: -300, dur: 3.9, delay: 0.95, peak: 0.34 }
  ];

  function spawnGhosts() {
    if (reduceMotion) return;

    var wrap = document.createElement('div');
    wrap.id = 'hw-ghosts';
    wrap.setAttribute('aria-hidden', 'true');

    var longest = 0;
    GHOSTS.forEach(function (g) {
      var el = document.createElement('div');
      el.className = 'hw-ghost';
      el.innerHTML = GHOST_SVG;
      el.style.left = g.left;
      el.style.top = g.top;
      el.style.width = g.w + 'px';
      el.style.setProperty('--hw-dx', g.dx + 'px');
      el.style.setProperty('--hw-dy', g.dy + 'px');
      el.style.setProperty('--hw-dur', g.dur + 's');
      el.style.setProperty('--hw-delay', g.delay + 's');
      el.style.setProperty('--hw-peak', g.peak);
      wrap.appendChild(el);
      longest = Math.max(longest, g.dur + g.delay);
    });

    document.body.appendChild(wrap);

    // Clear them out once they have faded, so they cost nothing afterwards.
    setTimeout(function () {
      if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
    }, (longest + 0.6) * 1000);
  }

  /* -------------------------------------------------------------------- build */
  function build() {
    if (document.getElementById('hw-spider')) return;

    ['left', 'right'].forEach(function (side) {
      var w = document.createElement('div');
      w.className = 'hw-web-corner hw-web-corner--' + side;
      w.setAttribute('aria-hidden', 'true');
      document.body.appendChild(w);
    });

    spawnGhosts();

    /* the spider is independently switchable from Theme settings */
    if (window.__hwSpider === false) return;

    var root = document.createElement('div');
    root.id = 'hw-spider';
    root.setAttribute('aria-hidden', 'true');

    var thread = document.createElement('div');
    thread.className = 'hw-thread';

    var body = document.createElement('div');
    body.className = 'hw-body';
    body.innerHTML = SPIDER_SVG;

    root.appendChild(thread);
    root.appendChild(body);
    document.body.appendChild(root);

    start(root, thread, body);
  }

  /* ------------------------------------------------------------------ motion */
  function start(root, thread, body) {
    var MIN_DROP = 72;           // how far below the top edge it hangs at rest
    var MAX_DROP_FRACTION = 0.7; // of viewport height, at full scroll
    var SCARE_RADIUS = 95;       // how close a pointer has to get
    var FLEE_MS = 1500;          // how long it stays spooked

    // base position, driven by scroll
    var curX = window.innerWidth / 2, tgtX = curX;
    var curY = MIN_DROP, tgtY = curY;
    // panic offset, added on top of the base position
    var fleeCX = 0, fleeTX = 0;
    var fleeCY = 0, fleeTY = 0;

    var fleeing = false;
    var fleeTimer = null;
    var raf = null;

    function measure() {
      var doc = document.documentElement;
      var scrollable = Math.max(1, doc.scrollHeight - window.innerHeight);
      var p = window.scrollY / scrollable;
      p = p < 0 ? 0 : p > 1 ? 1 : p;

      var maxDrop = window.innerHeight * MAX_DROP_FRACTION;
      tgtY = MIN_DROP + p * (maxDrop - MIN_DROP);

      var amplitude = Math.min(window.innerWidth * 0.3, 420);
      tgtX = window.innerWidth / 2 + Math.sin(p * Math.PI * 2.2) * amplitude;
    }

    function paint() {
      var x = curX + fleeCX;
      var y = curY + fleeCY;
      // the thread is only ever as long as the drop, so it never pokes out
      // underneath the spider when it bolts upward
      thread.style.height = Math.max(0, y) + 'px';
      body.style.top = y + 'px';
      root.style.transform = 'translate3d(' + x + 'px, 0, 0)';
    }

    function tick() {
      var ease = fleeing ? 0.3 : 0.085;   // bolts away fast, creeps back slowly
      var fleeEase = fleeing ? 0.3 : 0.055;

      curX += (tgtX - curX) * ease;
      curY += (tgtY - curY) * ease;
      fleeCX += (fleeTX - fleeCX) * fleeEase;
      fleeCY += (fleeTY - fleeCY) * fleeEase;
      paint();

      var settled =
        Math.abs(tgtX - curX) < 0.3 && Math.abs(tgtY - curY) < 0.3 &&
        Math.abs(fleeTX - fleeCX) < 0.3 && Math.abs(fleeTY - fleeCY) < 0.3;

      if (settled) {
        curX = tgtX; curY = tgtY;
        fleeCX = fleeTX; fleeCY = fleeTY;
        paint();
        raf = null;
      } else {
        raf = requestAnimationFrame(tick);
      }
    }

    function kick() {
      measure();
      if (reduceMotion) {
        curX = tgtX; curY = tgtY;
        fleeCX = fleeTX; fleeCY = fleeTY;
        paint();
        return;
      }
      if (!raf) raf = requestAnimationFrame(tick);
    }

    /* --- startle it ------------------------------------------------------- */
    function scare(px, py) {
      var sx = curX + fleeCX;
      var sy = curY + fleeCY + 40;           // roughly the spider's middle
      var dx = px - sx;
      var dy = py - sy;
      if (dx * dx + dy * dy > SCARE_RADIUS * SCARE_RADIUS) return;

      // bolt in the opposite direction, and scramble up the silk a little
      var away = dx === 0 ? (Math.random() < 0.5 ? -1 : 1) : (dx > 0 ? -1 : 1);
      var room = Math.max(140, window.innerWidth * 0.26);
      fleeTX = away * room;
      fleeTY = -Math.min(150, curY * 0.55);

      // keep it on screen
      var landing = curX + fleeTX;
      if (landing < 50) fleeTX = 50 - curX;
      if (landing > window.innerWidth - 50) fleeTX = window.innerWidth - 50 - curX;

      if (!fleeing) {
        fleeing = true;
        root.classList.add('is-fleeing');
      }
      if (fleeTimer) clearTimeout(fleeTimer);
      fleeTimer = setTimeout(calmDown, FLEE_MS);

      if (!raf) raf = requestAnimationFrame(tick);
    }

    function calmDown() {
      fleeing = false;
      fleeTX = 0;
      fleeTY = 0;
      root.classList.remove('is-fleeing');
      if (!raf) raf = requestAnimationFrame(tick);
    }

    /* --- wire up ---------------------------------------------------------- */
    measure();
    curX = tgtX;
    curY = tgtY;
    paint();

    window.addEventListener('scroll', kick, { passive: true });
    window.addEventListener('resize', kick, { passive: true });

    window.addEventListener('pointermove', function (e) {
      scare(e.clientX, e.clientY);
    }, { passive: true });

    window.addEventListener('touchstart', function (e) {
      var t = e.touches && e.touches[0];
      if (t) scare(t.clientX, t.clientY);
    }, { passive: true });

    window.addEventListener('touchmove', function (e) {
      var t = e.touches && e.touches[0];
      if (t) scare(t.clientX, t.clientY);
    }, { passive: true });

    // Browsers suspend requestAnimationFrame while a tab is hidden, so the
    // spider would otherwise crawl a long way to catch up when you come back.
    // Snap it straight to where it belongs instead.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) return;
      measure();
      curX = tgtX; curY = tgtY;
      fleeCX = fleeTX; fleeCY = fleeTY;
      paint();
    });

    // Testing hook, off unless the URL carries ?hwdebug=1.
    // The preview browser runs pages hidden, where requestAnimationFrame is
    // suspended, so the only way to exercise this motion is to step it by hand.
    if (!/[?&]hwdebug=1/.test(window.location.search)) return;

    window.__hwSpiderDebug = {
      scare: scare,
      state: function () {
        return {
          x: Math.round(curX + fleeCX),
          y: Math.round(curY + fleeCY),
          drop: Math.round(parseFloat(thread.style.height) || 0),
          fleeing: fleeing
        };
      },
      step: function (n) {
        for (var i = 0; i < (n || 1); i++) {
          var ease = fleeing ? 0.3 : 0.085;
          var fleeEase = fleeing ? 0.3 : 0.055;
          curX += (tgtX - curX) * ease;
          curY += (tgtY - curY) * ease;
          fleeCX += (fleeTX - fleeCX) * fleeEase;
          fleeCY += (fleeTY - fleeCY) * fleeEase;
        }
        paint();
      },
      sync: function () { measure(); }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
